<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="data"
      :loading="loading"
      loading-text="Загружаю действия"
      sort-by="createdAt"
      class="elevation-1"
      :items-per-page="15"
      :footer-props="{
        'items-per-page-options': [15, 30, 50, -1],
      }"
      height="calc(100vh - 177px)"
    >
      <template v-slot:item.action="{ item }">
        {{ getActionLabel(item.action) }}
      </template>
      <template v-slot:item.supportId="{ item }">
        <span>{{
          getSupportByAzureId(item.supportId)?.nickname || item.supportId
        }}</span>
      </template>
      <template v-slot:item.startTime="{ item }">
        <span>{{ formatTimestampToHumanReadableDate(item.startTime) }}</span>
      </template>
      <template v-slot:item.createdAt="{ item }">
        <span>{{ formatTimestampToHumanReadableDate(item.createdAt) }}</span>
      </template>
      <template v-slot:item.duration="{ item }">
        <span>{{ formatTimestampDifference(item.duration) }}</span>
      </template>
      <template v-slot:item.chatId="{ item }">
        <span>{{ getChatInfo(item.chatId) }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  formatTimestampDifference,
  getISODate,
  formatTimestampToHumanReadableDate,
} from '@/lib/utils';
import { CHAT_ACTIONS_MAP } from '@/models/actions';
import { DEPARTMENT } from '@/models/departments';

// update once department filter for analytics is added (can work similar to how getActionLabel works in ActionsSection)
const ALL_CHAT_ACTIONS = [
  ...CHAT_ACTIONS_MAP[DEPARTMENT.REGISTER],
  ...CHAT_ACTIONS_MAP[DEPARTMENT.FINANCES],
];

export default {
  name: 'ActionsTable',

  props: {
    data: Array,
    loading: Boolean,
  },

  data() {
    return {
      getISODate,
      formatTimestampDifference,
      formatTimestampToHumanReadableDate,
      actions: ALL_CHAT_ACTIONS,

      headers: [
        { text: 'Действие', value: 'action' },
        { text: 'Саппорт', value: 'supportId' },
        { text: 'Начато', value: 'startTime' },
        { text: 'Закончено', value: 'createdAt' },
        { text: 'Длительность', value: 'duration' },
        { text: 'Чат', value: 'chatId' },
      ],
    };
  },

  computed: {
    ...mapGetters('adminSupport', {
      getSupportByAzureId: 'getSupportByAzureId',
    }),
    // add byId storage to admin panel (like v2 in support view)
    chatsById() {
      return new Map(this.$store.state.adminChat.chats.map(i => [i.chatId, i]));
    },
  },

  methods: {
    getActionLabel(action) {
      const actionLabel = this.actions.find(
        ({ value }) => value === action
      )?.text;

      return actionLabel || action;
    },

    getChatInfo(chatId) {
      try {
        const { from, userIds } = this.chatsById.get(chatId);
        let name = `${from?.first_name || ''} ${from?.last_name || ''}`;
        if (name.trim().length === 0) name = from?.username;

        const res = [];
        if (name.trim()) res.push(name.trim());
        if (userIds?.length > 0) userIds.forEach(userId => res.push(userId));

        if (res.length > 0) {
          return res.join(', ');
        }

        return 'No name';
      } catch (e) {
        console.error(e);
        return 'No name';
      }
    },
  },
};
</script>
